// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","ArrowHeight":"30px","container":"G21b793","tooltip__content":"Gdb2905","close":"Gdd89f3"};